import { CustomTextLayerProps } from './CustomTextLayer.props';

const CustomTextLayer = ({ words, pageWidth, renderedWidth }: CustomTextLayerProps) => {
  const scale = renderedWidth / pageWidth;

  // Append a trailing space to a word when the next word sits on the same line
  // with a small gap, so copied text keeps word boundaries. We intentionally do
  // NOT widen the word box to reach the next word - stretching the box made the
  // selection geometry grow past the real term while dragging (SCAL-8986).
  const processedWords = words.map((word, i) => {
    const next = words[i + 1];
    const sameLine = next && Math.abs(next.top - word.top) < word.height * 0.5 && next.left > word.left;
    const gap = sameLine ? next.left - (word.left + word.width) : 0;
    const text = sameLine && gap > 0 && gap < word.height * 2 ? `${word.text} ` : word.text;
    return { ...word, text };
  });

  return (
    <>
      {processedWords.map((word, i) => (
        <span
          key={word.id}
          data-word-id={word.id}
          data-index={i}
          style={{
            position: 'absolute',
            left: `${word.left * scale}px`,
            top: `${word.top * scale}px`,
            width: `${word.width * scale}px`,
            height: `${word.height * scale}px`,
            // Font size tracks the box height 1:1 so the selection band stays a
            // consistent size across words and lines (SCAL-8986).
            fontSize: `${word.height * scale}px`,
            color: 'transparent',
            cursor: 'text',
            userSelect: 'text',
            WebkitUserSelect: 'text',
            lineHeight: `${word.height * scale}px`,
            whiteSpace: 'pre',
          }}>
          {word.text}
        </span>
      ))}
    </>
  );
};

export default CustomTextLayer;
